export default __webpack_public_path__ + "roboto-v27-latin-700.44eb15.woff";